import React, { useEffect, useReducer, useState } from 'react';
import PageContainer from '../../components/PageContainer';
import MainContent from '../../components/MainContent';
import PageTitle from '../../components/Common/PageTitle/PageTitle';
import Notification from '../../components/Common/Notification';
import './EnterMarksPage.css';
import { useConfig } from '../../DataStore/ConfigContext';
import { useMarks } from '../../DataStore/MarksContext';
import ActivityLoader from '../../components/Common/ActivityLoader';
import { useTheme } from '../../DataStore/ThemeContext';
import ajaxMark from '../../util/remote/ajaxMark';
import ActionDropdownItem from '../../components/Common/PageTitle/ActionDropdownItem';
import MarksEntryFilter from '../../components/Academics/MarksEntry/MarksEntryFilter';

const initialState = {
  class: null,
  stream: null,
  subject: null,
  marks: {},
  loaded: false,
  showFilter: true,
  searchQuery: '',
};

function reducer(state, action) {
  switch (action.type) {
    case 'TOGGLE_FILTER':
      return { ...state, showFilter: !state.showFilter };
    case 'SET_SEARCH_QUERY':
      return { ...state, searchQuery: action.value };
    case 'HIDE_FILTER':
      return { ...state, showFilter: false };
    case 'RESET':
      return initialState;
    default:
      return state;
  }
}

const EnterMarksPage = () => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const { classes, getClasses, currentAcademicPeriod, getCurrentAcademicPeriod } = useConfig();
  const { setNotify } = useTheme();

  const [marksInput, setMarksInput] = useState({});
  const [typingTimeouts, setTypingTimeouts] = useState({});
  const [combinedOptions, setCombinedOptions] = useState([]);

 
  const {
    getSubjectPapers,
    paperListing,
    getMarksEntryForm,
    setEntryClass,
    setEntryStream,
    setEntryPaper,
    entryStream,
    entryClass,
    entryPaper,
    marksEntryLoad,
    marksForm,
    loadingMarksForm,
    getMarksEntryLoad,
  } = useMarks();

  useEffect(() => {
    getClasses();
    getSubjectPapers();
    getCurrentAcademicPeriod();
    getMarksEntryLoad();
  }, []);


  useEffect(() => {
    if (Array.isArray(marksForm)) {
      dispatch({ type: 'HIDE_FILTER' });
    }
  }, [marksForm]);

  // console.log('marksEntryLoad', marksEntryLoad);

  useEffect(() => {
  if (Array.isArray(marksEntryLoad)) {
    const options = marksEntryLoad.map(entry => ({
      label: `${entry.class.class_name} - ${entry.stream !== false ? entry.stream.stream_name : ''} - ${entry.paper.subject.subject} (${entry.paper.paper})`,
      value: entry
    }));
    setCombinedOptions(options);
  }
}, [marksEntryLoad]);



  let classOptions = [];
  let streamOptions = [];
  let subjectOptions = [];

  const isCombinedMode = Array.isArray(marksEntryLoad) && marksEntryLoad.length > 0;

  if (marksEntryLoad === '404') {
    classOptions = [];
    streamOptions = [];
    subjectOptions = [];
  } else if (marksEntryLoad === 'SUPER_MARKS_ENTRY') {
    classOptions = Array.isArray(classes)
      ? classes.map(cls => ({
          label: `${cls.class_name} (${cls.level?.level || ''})`,
          value: cls,
          streams: cls.streams || [],
        }))
      : [];

    streamOptions = entryClass?.streams ? entryClass.streams.map(s => ({ label: s.stream_name, value: s.stream_id })) : [];

    subjectOptions = Array.isArray(paperListing) && entryClass?.level?.level_id
      ? paperListing
          .filter(paper => paper.subject.level.level_id === entryClass.level.level_id)
          .map(paper => ({ label: `${paper.subject.subject} (${paper.paper_code})`, value: paper.paper_id }))
      : [];
  } else if (isCombinedMode) {
    // setCombinedOptions(
    //   marksEntryLoad.map(entry => ({
    //     label: `${entry.class.class_name} - ${entry.stream.stream_name} (${entry.paper.subject.subject})`,
    //     value: entry
    //   }))
    // );
  }


  const handleCombinedChange = (item) => {
    //if (!item?.value) return;
    const { class: classObj, stream, paper } = item;
    setEntryClass(classObj);
    setEntryStream({ label: stream.stream_name, value: stream.id });
    setEntryPaper({ label: `${paper.subject.subject} (${paper.paper})`, value: paper.paper_id });
  };

  const handleLoadStudents = () => {
    if (!entryClass || !entryPaper) {
      setNotify(<Notification type="danger" message="Please select class and subject to load students." />);
      return;
    }
    getMarksEntryForm();
  };

  const classLabel = entryClass?.class_name || '';
  const streamLabel = entryStream?.label || '';
  const subjectLabel = entryPaper?.label || '';

  const filteredStudents = Array.isArray(marksForm)
    ? marksForm.filter(record => {
        const q = (state.searchQuery || '').toLowerCase();
        return (
          (record.student.reg_no?.toLowerCase() || '').includes(q) ||
          (record.student.full_name?.toLowerCase() || '').includes(q)
        );
      })
    : [];

  const addMark = async (id, value) => {
    setNotify(false);
    const server_response = await ajaxMark.enterMark({
      mark_id: id,
      mark: value,
    });
    if (server_response.status === "OK") {
        // setNotify(<Notification type="success" message={server_response.message} />);
      getMarksEntryForm();
    } else {
      setNotify(<Notification type="info" message={server_response.message} />);
    }
  };



  // Handles mark input and debounces API call
  const handleMarkChange = (id, value) => {
    // Validate numeric input between 0 and 100
    const markValue = value

    // Update input state
    setMarksInput(prev => ({ ...prev, [id]: markValue }));

    // Clear existing timeout
    if (typingTimeouts[id]) clearTimeout(typingTimeouts[id]);

    // Set new timeout to auto-save after delay
    const timeout = setTimeout(() => {
      addMark(id, markValue);
    }, 1000); // 1 second debounce

    setTypingTimeouts(prev => ({ ...prev, [id]: timeout }));
  };

  
  const PageActions = () => (
        <>
            <ActionDropdownItem iconClass="fa fa-plus text-primary" label="Commit Marks"/>
            <ActionDropdownItem iconClass="fa fa-sync text-primary" label="Refresh" onClick={getMarksEntryForm}/>
        </>
    );


  return (
    <>
      <PageContainer>
        <MainContent>
          <PageTitle
            title="Enter Marks"
            description="Record marks for current term: Select class/stream and subject."
            iconClass="fa fa-book"
            PageActions={PageActions}
            sticky
          />

         {marksEntryLoad !== '404' && <div className="text-end mb-2">
            <button
              className="btn btn-sm btn-light border"
              onClick={() => dispatch({ type: 'TOGGLE_FILTER' })}
            >
              <i className={`fa ${state.showFilter ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i> Filters
            </button>
          </div>}

          {!state.showFilter && Array.isArray(marksForm) && (
            <div className="alert alert-secondary d-flex align-items-center justify-content-between">
              <div className="fw-semibold">
                <i className="fa fa-bullseye me-2 text-primary"></i>&nbsp;
                Currently entering: <strong>{classLabel} {streamLabel && ` ${streamLabel}`} - {subjectLabel}</strong> (Term {currentAcademicPeriod?.term.term} {currentAcademicPeriod?.acad_year})
              </div>
              <button
                className="btn btn-sm btn-outline-primary"
                onClick={() => dispatch({ type: 'TOGGLE_FILTER' })}
              >
                Change
              </button>
            </div>
          )}

          {marksEntryLoad !== '404' && <MarksEntryFilter
              showFilter={state.showFilter}
              isCombinedMode={isCombinedMode}
              combinedOptions={combinedOptions}
              handleCombinedChange={handleCombinedChange}
              classOptions={classOptions}
              streamOptions={streamOptions}
              subjectOptions={subjectOptions}
              entryClass={entryClass}
              entryStream={entryStream}
              entryPaper={entryPaper}
              setEntryClass={setEntryClass}
              setEntryStream={setEntryStream}
              setEntryPaper={setEntryPaper}
              handleLoadStudents={handleLoadStudents}
        />}

          {!Array.isArray(marksForm) && !loadingMarksForm && marksEntryLoad !== '404' &&  <Notification message="Please select class and subject to begin." />}

          {(Array.isArray(marksForm)) && (
            <>
              <div className="mb-3">
                <div className="input-group input-group-lg bg-white">
                  <span className="input-group-text bg-white border-end-0">
                    <i className="fa fa-search text-muted"></i>
                  </span>
                  <input
                    type="text"
                    className="form-control border-start-0 rounded-end search-input"
                    placeholder="Search by name or reg. no"
                    value={state.searchQuery}
                    onChange={(e) => dispatch({ type: 'SET_SEARCH_QUERY', value: e.target.value })}
                  />
                </div>
              </div>

              <div className="table-responsive card mb-3">
                <table className="table table-striped table-hover align-middle">
                  <thead className="table-light">
                    <tr>
                      <th>No.</th>
                      <th>Reg. No</th>
                      <th>Student Name</th>
                      <th>Class</th>
                      <th style={{ width: '140px' }}>&nbsp;</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredStudents.map((record, index) => (
                      <tr key={record.student.id}>
                        <td>{index + 1}</td>
                        <td>{record.student.reg_no}</td>
                        <td>{record.student.full_name}</td>
                        <td>{record.student.class.class_name}</td>
                        <td>
                          <div className="input-group input-group-sm">
                            <span className="input-group-text"><i className="fa fa-pen text-primary"></i></span>
                            <input
                              type="text"
                              inputMode='decimal'
                              pattern="^\d*\.?\d*$"
                              className="form-control text-center"
                              required
                              value={marksInput[record.id] !== undefined ? marksInput[record.id] : (record.mark || '')}
                              onChange={(e) => {
                                const value = e.target.value;
                                // Allow numbers like 85, 85.6, .5, 90.
                                if (/^(\d+(\.\d*)?|\.\d*)?$/.test(value)) {
                                  handleMarkChange(record.id, value);
                                }
                              }}
                              maxLength={4}
                            />
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          )}

          {loadingMarksForm && <ActivityLoader />}
          {marksEntryLoad === '404' && (
            <Notification type="warning" message="No teaching load assigned. Please contact the administrator." />
          )}

        </MainContent>
      </PageContainer>
      
    </>
  );
};

export default EnterMarksPage;
